import { signInWithRedirect, signOut as amplifySignOut, getCurrentUser as amplifyGetCurrentUser, fetchUserAttributes, fetchAuthSession } from 'aws-amplify/auth';

export async function signIn() {
  return signInWithRedirect({ provider: { custom: 'Midway' } });
}

export async function signOut() {
  return amplifySignOut();
}

export async function getCurrentUser() {
  try {
    const user = await amplifyGetCurrentUser();
    let userId = null;
    try {
      const session = await fetchAuthSession();
      const payload = session.tokens?.idToken?.payload;
      // identities may be a JSON string or array depending on token version
      let identities = payload?.identities;
      if (typeof identities === 'string') {
        try { identities = JSON.parse(identities); } catch {}
      }
      if (identities?.[0]?.userId) {
        userId = identities[0].userId;
      }
      // Fallback: extract alias from email claim if present
      if (!userId && payload?.email) {
        userId = payload.email.split('@')[0];
      }
    } catch {}
    try {
      const attrs = await fetchUserAttributes();
      if (!userId && attrs.email) {
        userId = attrs.email.split('@')[0];
      }
      return { username: attrs.email || attrs.given_name || user.username, userId, isSignedIn: true };
    } catch {
      const alias = user.username.replace(/^midway_/i, '');
      if (!userId) userId = alias;
      return { username: alias + '@amazon.com', userId, isSignedIn: true };
    }
  } catch {
    return { username: null, userId: null, isSignedIn: false };
  }
}
